// extracted by mini-css-extract-plugin
export default {"textArea":"GJ4hC__textArea"};